export function calculateImageBrightness(imageSrc, callback) {
  const img = document.createElement('img');
  img.src = imageSrc;
  img.style.display = 'none';
  document.body.appendChild(img);

  let colorSum = 0;

  img.onload = e => {
    // Create canvas.
    const element = e.currentTarget;
    const canvas = document.createElement('canvas');
    canvas.width = element.width;
    canvas.height = element.height;

    const ctx = canvas.getContext('2d');
    ctx.drawImage(element, 0, 0);

    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const { data } = imageData;
    let r;
    let g;
    let b;
    let avg;

    for (let x = 0, len = data.length; x < len; x += 4) {
      r = data[x];
      g = data[x + 1];
      b = data[x + 2];

      avg = Math.floor((r + g + b) / 3);
      colorSum += avg;
    }

    const brightness = Math.floor(colorSum / (element.width * element.height));
    callback(brightness);
  };
}

export function sharePopup(e, intWidth, intHeight, blnResize) {
  // Prevent default anchor event
  e.preventDefault();
  const element = e.currentTarget;

  // Set values for window
  intWidth = intWidth || '500';
  intHeight = intHeight || '400';
  const strResize = blnResize ? 'yes' : 'no';

  // Set title and open popup with focus on it
  const strTitle =
    typeof element.getAttribute('title') !== 'undefined'
      ? element.getAttribute('title')
      : 'Social Share';

  const strParam = `width=${intWidth},height=${intHeight},resizable=${strResize}`;

  window.open(element.getAttribute('href'), strTitle, strParam).focus();
}

export function viewport() {
  let e = window;
  let a = 'inner';
  if (!('innerWidth' in window)) {
    a = 'client';
    e = document.documentElement || document.body;
  }
  return { width: e[`${a}Width`], height: e[`${a}Height`] };
}

export function inViewport(el) {
  const elH = el[0].offsetHeight;
  const H = window.innerHeight;
  const r = el[0].getBoundingClientRect();
  const t = r.top;
  const b = r.bottom;

  let iv;
  if (t > 0) {
    iv = Math.min(elH, H - t);
  } else if (b < H) {
    iv = b;
  } else {
    iv = H;
  }

  // TODO: check if the if-structure is correct
  // return Math.max(0, t > 0 ? Math.min(elH, H - t) : b < H ? b : H);

  return iv;
}
